/* My Event Lab — configurator + small helpers */
(function () {
  'use strict';

  var money = function (cents) {
    var v = cents / 100;
    return '£' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var lc = function (s) { return String(s || '').toLowerCase(); };

  /* ---------- colours by name ---------- */
  var COLOURS = {
    unpainted: '#C8A877', natural: '#C8A877', raw: '#C8A877', mdf: '#C8A877',
    white: '#F3F2EE', black: '#1E1C18', cream: '#EFE4CF', pink: '#E8789B', blue: '#3E6FD8',
    gold: 'url(#mel-gold)', silver: 'url(#mel-silver)', navy: '#181357', green: '#8FAE8B', sage: '#8FAE8B'
  };
  function colourFor(name, custom) {
    var n = lc(name);
    if (n.indexOf('custom') > -1) return custom || '#8FAE8B';
    if (n.indexOf('vinyl') > -1) return 'url(#mel-vinyl)';
    for (var k in COLOURS) if (n.indexOf(k) > -1) return COLOURS[k];
    return null;
  }
  function swatchCss(name) {
    var n = lc(name);
    if (n.indexOf('gold') > -1) return 'linear-gradient(135deg,#B8892B,#F6DB8F 45%,#B8892B 55%,#8C6517)';
    if (n.indexOf('silver') > -1) return 'linear-gradient(135deg,#9EA3A8,#F4F5F7 45%,#9EA3A8 55%,#6F747A)';
    if (n.indexOf('custom') > -1) return 'conic-gradient(#E5487A,#F2A93B,#FFD166,#3FA7C4,#7B5CFF,#E5487A)';
    if (n.indexOf('vinyl') > -1) return 'repeating-linear-gradient(45deg,#FB97DF 0 6px,#fff 6px 12px)';
    var c = colourFor(name);
    return c && c.indexOf('url') !== 0 ? c : '#ddd';
  }

  /* ---------- shapes (SVG path in a W×H box at x0,y0) ---------- */
  function outline(kind, W, H, x0, y0) {
    var f = function (n) { return Math.round(n * 10) / 10; };
    var R = x0 + W, B = y0 + H, r, ry, d, i;
    switch (kind) {
      case 'rounded':
        r = Math.min(W, H) * 0.08;
        return 'M' + f(x0 + r) + ' ' + f(y0) + ' H' + f(R - r) + ' A' + f(r) + ' ' + f(r) + ' 0 0 1 ' + f(R) + ' ' + f(y0 + r) + ' V' + f(B - r) + ' A' + f(r) + ' ' + f(r) + ' 0 0 1 ' + f(R - r) + ' ' + f(B) + ' H' + f(x0 + r) + ' A' + f(r) + ' ' + f(r) + ' 0 0 1 ' + f(x0) + ' ' + f(B - r) + ' V' + f(y0 + r) + ' A' + f(r) + ' ' + f(r) + ' 0 0 1 ' + f(x0 + r) + ' ' + f(y0) + ' Z';
      case 'arch':
        r = W / 2; ry = Math.min(r, H);
        return 'M' + f(x0) + ' ' + f(B) + ' V' + f(y0 + ry) + ' A' + f(r) + ' ' + f(ry) + ' 0 0 1 ' + f(R) + ' ' + f(y0 + ry) + ' V' + f(B) + ' Z';
      case 'scallop':
        r = W / 6; ry = Math.min(r, H * 0.3); d = 'M' + f(x0) + ' ' + f(B) + ' V' + f(y0 + ry);
        for (i = 1; i <= 3; i++) d += ' A' + f(r) + ' ' + f(ry) + ' 0 0 1 ' + f(x0 + i * 2 * r) + ' ' + f(y0 + ry);
        return d + ' V' + f(B) + ' Z';
      case 'wave':
        return 'M' + f(x0) + ' ' + f(B) + ' V' + f(y0 + H * 0.18) + ' C' + f(x0 + W * 0.3) + ' ' + f(y0 - H * 0.06) + ' ' + f(x0 + W * 0.55) + ' ' + f(y0 + H * 0.28) + ' ' + f(R) + ' ' + f(y0 + H * 0.06) + ' V' + f(B) + ' Z';
      case 'layered':
        return 'M' + f(x0) + ' ' + f(B) + ' V' + f(y0 + H * 0.12) + ' Q' + f(x0 + W * 0.25) + ' ' + f(y0 - H * 0.04) + ' ' + f(x0 + W * 0.5) + ' ' + f(y0 + H * 0.12) + ' T' + f(R) + ' ' + f(y0 + H * 0.12) + ' V' + f(B) + ' Z';
      case 'oval':
        var cy = y0 + H / 2;
        return 'M' + f(x0) + ' ' + f(cy) + ' A' + f(W / 2) + ' ' + f(H / 2) + ' 0 1 1 ' + f(R) + ' ' + f(cy) + ' A' + f(W / 2) + ' ' + f(H / 2) + ' 0 1 1 ' + f(x0) + ' ' + f(cy) + ' Z';
      default:
        return 'M' + f(x0) + ' ' + f(y0) + ' H' + f(R) + ' V' + f(B) + ' H' + f(x0) + ' Z';
    }
  }
  function shapeFrom(text, fallback) {
    var t = lc(text);
    if (!t) return fallback;
    if (t.indexOf('scallop') > -1) return 'scallop';
    if (t.indexOf('layer') > -1) return 'layered';
    if (t.indexOf('wave') > -1) return 'wave';
    if (t.indexOf('round') > -1) return 'rounded';
    if (t.indexOf('oval') > -1 || t.indexOf('circle') > -1) return 'oval';
    if (t.indexOf('rect') > -1 || t.indexOf('square') > -1) return 'rect';
    if (t.indexOf('arch') > -1) return 'arch';
    return fallback;
  }
  /* size text → {w,h} in feet. Understands "4ft wide × 6ft tall", "6ft × 4ft", "90 × 180cm", "6ft". */
  function sizeFrom(text, mode) {
    var t = lc(text).replace(/,/g, '.');
    var wide = t.match(/(\d+(?:\.\d+)?)\s*ft\s*wide/), tall = t.match(/(\d+(?:\.\d+)?)\s*ft\s*(?:tall|high)/);
    if (wide && tall) return { w: +wide[1], h: +tall[1] };
    var cm = t.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*cm/);
    if (cm) return { w: +cm[1] / 30.48, h: +cm[2] / 30.48 };
    var ft2 = t.match(/(\d+(?:\.\d+)?)\s*ft?\s*[x×]\s*(\d+(?:\.\d+)?)\s*ft/);
    if (ft2) return mode === 'arch3d' ? { h: +ft2[1], w: +ft2[2] } : { w: +ft2[1], h: +ft2[2] };
    var one = t.match(/(\d+(?:\.\d+)?)\s*ft/);
    if (one) return { h: +one[1], w: +one[1] / 2 };
    return null;
  }

  /* ---------- configurator ---------- */
  function Cfg(root) {
    this.root = root;
    this.mode = root.getAttribute('data-mode') || 'backdrop';
    this.defShape = root.getAttribute('data-shape') || 'arch';
    this.person = root.getAttribute('data-person') === 'true';
    this.checkout = root.getAttribute('data-checkout') || 'cart';
    this.kind = root.getAttribute('data-kind') || '';
    this.qtyEl = root.querySelector('[data-mel-qty]');
    this.data = JSON.parse(root.querySelector('[data-mel-product]').textContent);
    this.form = root.querySelector('[data-mel-form]');
    this.preview = root.querySelector('[data-mel-preview]');
    this.artUrl = '';
    var cur = this.find(this.data.current) || this.data.variants[0];
    this.sel = cur.options.slice();
    this.addons = {}; // groupIndex -> { productId: variantId }
    this.bind();
    this.update();
  }
  Cfg.prototype.find = function (id) {
    for (var i = 0; i < this.data.variants.length; i++) if (this.data.variants[i].id === id) return this.data.variants[i];
  };
  Cfg.prototype.match = function (opts) {
    var vs = this.data.variants;
    for (var i = 0; i < vs.length; i++) {
      var ok = true;
      for (var j = 0; j < opts.length; j++) if (vs[i].options[j] !== opts[j]) { ok = false; break; }
      if (ok) return vs[i];
    }
    return null;
  };
  Cfg.prototype.variant = function () {
    var v = this.match(this.sel);
    if (v) return v;
    // keep the most recent choice; fill the rest from the first variant that has it
    var vs = this.data.variants, last = this.lastOpt || 0;
    for (var i = 0; i < vs.length; i++) if (vs[i].options[last] === this.sel[last]) { this.sel = vs[i].options.slice(); return vs[i]; }
    this.sel = vs[0].options.slice();
    return vs[0];
  };
  Cfg.prototype.optValue = function (re) {
    for (var i = 0; i < this.data.options.length; i++) if (re.test(this.data.options[i])) return this.sel[i];
    return '';
  };
  Cfg.prototype.prop = function (role) {
    var els = this.form.querySelectorAll('[data-mel-role="' + role + '"]');
    for (var i = 0; i < els.length; i++) if (!els[i].closest('[hidden]') && !els[i].disabled && els[i].value) return els[i].value;
    return '';
  };
  Cfg.prototype.allText = function () {
    var parts = this.sel.slice();
    this.form.querySelectorAll('[data-mel-prop-value][aria-pressed="true"]').forEach(function (b) {
      if (b.closest('[data-mel-when]')) return; // conditional rows never switch themselves on
      parts.push(b.getAttribute('data-mel-prop-value'));
    });
    this.form.querySelectorAll('[data-mel-addon][aria-pressed="true"]').forEach(function (b) { parts.push(b.textContent); });
    return lc(parts.join(' | '));
  };

  Cfg.prototype.bind = function () {
    var self = this;
    // variant options
    this.form.querySelectorAll('[data-mel-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = +b.getAttribute('data-mel-opt');
        self.sel[i] = b.getAttribute('data-value');
        self.lastOpt = i;
        self.update();
      });
    });
    // finish dots
    this.form.querySelectorAll('[data-mel-dot]').forEach(function (d) { d.style.background = swatchCss(d.getAttribute('data-mel-dot')); });
    // property choice buttons
    this.form.querySelectorAll('fieldset').forEach(function (fs) {
      var hidden = fs.querySelector('input[type="hidden"]');
      if (!hidden) return;
      fs.querySelectorAll('[data-mel-prop-value]').forEach(function (b) {
        b.addEventListener('click', function () {
          fs.querySelectorAll('[data-mel-prop-value]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          hidden.value = b.getAttribute('data-mel-prop-value');
          self.update();
        });
      });
    });
    // add-on groups
    this.form.querySelectorAll('[data-mel-addons]').forEach(function (fs, gi) {
      var radio = fs.getAttribute('data-mel-addons') === 'radio';
      var box = fs.querySelector('[data-mel-addon-variants]');
      self.addons[gi] = {};
      fs._gi = gi;
      fs.querySelectorAll('[data-mel-addon]').forEach(function (b) {
        b.addEventListener('click', function () {
          var pid = b.getAttribute('data-mel-addon');
          var on = b.getAttribute('aria-pressed') === 'true';
          if (radio) {
            fs.querySelectorAll('[data-mel-addon]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
            self.addons[gi] = {};
            if (pid) { var p = self.addonData(pid); self.addons[gi][pid] = p.variants[0].id; }
          } else {
            b.setAttribute('aria-pressed', on ? 'false' : 'true');
            if (on) delete self.addons[gi][pid]; else { var q = self.addonData(pid); self.addons[gi][pid] = q.variants[0].id; }
          }
          self.renderAddonVariants(fs, box, gi);
          self.update();
        });
      });
    });
    // inputs
    this.form.querySelectorAll('input[type="text"]').forEach(function (i) { i.addEventListener('input', function () { self.update(); }); });
    var pick = this.form.querySelector('[data-mel-colour-picker]'), hex = this.form.querySelector('[data-mel-role="colour"]');
    if (pick && hex) {
      pick.addEventListener('input', function () { hex.value = pick.value.toUpperCase(); self.update(); });
      hex.addEventListener('input', function () { if (/^#[0-9a-f]{6}$/i.test(hex.value.trim())) pick.value = hex.value.trim(); });
    }
    var art = this.form.querySelector('[data-mel-role="artwork"]');
    if (art) art.addEventListener('change', function () {
      var f = art.files && art.files[0];
      if (self.artUrl) URL.revokeObjectURL(self.artUrl);
      self.artUrl = f && /^image\//.test(f.type) ? URL.createObjectURL(f) : '';
      self.update();
    });
    this.form.addEventListener('submit', function (e) { e.preventDefault(); });
    var sb = this.root.querySelector('[data-mel-submit]');
    if (sb) sb.addEventListener('click', function () { self.submit(); });
    if (this.qtyEl) {
      this.qtyEl.addEventListener('input', function () { self.update(); });
      this.root.querySelectorAll('[data-mel-qty-preset]').forEach(function (b) {
        b.addEventListener('click', function () { self.qtyEl.value = b.getAttribute('data-mel-qty-preset'); self.update(); });
      });
    }
    var qf = this.root.querySelector('[data-mel-quote]') || this.root.querySelector('#mel-quote-form');
    if (qf) qf.addEventListener('submit', function () {
      var body = qf.querySelector('[data-mel-quote-body]');
      if (body) body.value = self.specRows().map(function (r) { return r[0] + ': ' + r[1]; }).join('\n');
    });
  };
  Cfg.prototype.addonData = function (pid) {
    var el = this.form.querySelector('[data-mel-addon-data="' + pid + '"]');
    return el ? JSON.parse(el.textContent) : null;
  };
  Cfg.prototype.renderAddonVariants = function (fs, box, gi) {
    var self = this, ids = Object.keys(this.addons[gi]);
    box.innerHTML = '';
    var shown = false;
    ids.forEach(function (pid) {
      var p = self.addonData(pid);
      if (!p || p.variants.length < 2) return;
      shown = true;
      p.variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'mel-swatch';
        b.title = v.title + ' · +' + money(v.price);
        b.setAttribute('aria-label', v.title + ', plus ' + money(v.price));
        b.style.background = swatchCss(v.title);
        b.setAttribute('aria-pressed', self.addons[gi][pid] === v.id ? 'true' : 'false');
        b.addEventListener('click', function () { self.addons[gi][pid] = v.id; self.renderAddonVariants(fs, box, gi); self.update(); });
        box.appendChild(b);
      });
    });
    box.hidden = !shown;
  };
  Cfg.prototype.chosenAddons = function () {
    var out = [], self = this;
    this.form.querySelectorAll('[data-mel-addons]').forEach(function (fs) {
      if (fs.hidden) return;
      var g = self.addons[fs._gi] || {};
      Object.keys(g).forEach(function (pid) {
        var p = self.addonData(pid), v = null;
        p.variants.forEach(function (x) { if (x.id === g[pid]) v = x; });
        if (v) out.push({ product: p, variant: v, role: fs.getAttribute('data-mel-addon-role') });
      });
    });
    return out;
  };

  Cfg.prototype.qty = function () {
    if (!this.qtyEl) return 1;
    var min = parseInt(this.qtyEl.getAttribute('min'), 10) || 1, q = parseInt(this.qtyEl.value, 10);
    return isNaN(q) ? min : Math.max(min, q);
  };
  Cfg.prototype.specRows = function () {
    var self = this, rows = this.data.options.filter(function (o) { return o !== 'Title'; }).map(function (o) { return [o, self.sel[self.data.options.indexOf(o)]]; });
    this.form.querySelectorAll('input[name^="properties["]').forEach(function (i) {
      if (i.disabled || i.type === 'file' || !i.value) return;
      rows.push([i.name.slice(11, -1), i.value]);
    });
    if (this.qtyEl) rows.push(['Quantity', String(this.qty())]);
    this.chosenAddons().forEach(function (a) { rows.push(['Extra', a.product.title + (a.product.variants.length > 1 ? ' · ' + a.variant.title : '')]); });
    return rows;
  };
  Cfg.prototype.update = function () {
    var self = this, v = this.variant();
    // option chips + price deltas
    var base = v.price;
    this.form.querySelectorAll('[data-mel-opt]').forEach(function (b) {
      var i = +b.getAttribute('data-mel-opt'), val = b.getAttribute('data-value');
      b.setAttribute('aria-pressed', self.sel[i] === val ? 'true' : 'false');
      var test = self.sel.slice(); test[i] = val;
      var m = self.match(test), small = b.querySelector('[data-mel-delta]');
      if (small) {
        if (!m) { small.textContent = 'n/a'; b.style.opacity = '.55'; }
        else { b.style.opacity = ''; var d = m.price - base; small.textContent = self.sel[i] === val ? (d === 0 && m.price ? money(m.price) : '') : (d === 0 ? 'Same price' : (d > 0 ? '+' : '−') + money(Math.abs(d))); }
      }
    });
    this.form.querySelectorAll('[data-mel-chosen]').forEach(function (s) { s.textContent = self.sel[+s.getAttribute('data-mel-chosen')]; });
    // conditional rows
    var all = this.allText();
    this.form.querySelectorAll('[data-mel-when]').forEach(function (el) {
      var keys = lc(el.getAttribute('data-mel-when')).split(',');
      var show = keys.some(function (k) { k = k.trim(); return k && all.indexOf(k) > -1; });
      el.hidden = !show;
      el.querySelectorAll('input').forEach(function (i) { i.disabled = !show; });
    });
    // add-on label
    this.form.querySelectorAll('[data-mel-addons]').forEach(function (fs) {
      var span = fs.querySelector('[data-mel-addon-chosen]'), g = self.addons[fs._gi] || {}, names = [];
      Object.keys(g).forEach(function (pid) { var p = self.addonData(pid); p.variants.forEach(function (x) { if (x.id === g[pid]) names.push(p.variants.length > 1 ? x.title : ''); }); });
      if (span) span.textContent = names.filter(Boolean).join(', ');
    });
    // summary
    var addons = this.chosenAddons(), qty = this.qty(), total = v.price * qty, lines = [], quote = this.checkout === 'quote';
    var vt = v.title === 'Default Title' ? '' : ' · ' + esc(v.title);
    if (quote) {
      lines = this.specRows().map(function (r) { return '<div class="mel-summary__line"><span>' + esc(r[0]) + '</span><span>' + esc(r[1]) + '</span></div>'; });
      this.root.querySelector('[data-mel-lines]').innerHTML = lines.join('') + '<p class="mel-help" style="margin-top:6px">We\'ll come back with an exact price within one working day.</p>';
    } else {
    lines.push('<div class="mel-summary__line"><span>' + esc(this.data.title) + vt + (qty > 1 ? ' × ' + qty : '') + '</span><span>' + money(v.price * qty) + '</span></div>');
    this.root.querySelectorAll('[data-mel-qty-preset]').forEach(function (b) {
      var n = parseInt(b.getAttribute('data-mel-qty-preset'), 10); b.setAttribute('aria-pressed', n === qty ? 'true' : 'false');
      var sm = b.querySelector('[data-mel-qty-price]'); if (sm) sm.textContent = money(v.price * n);
    });
    addons.forEach(function (a) {
      total += a.variant.price;
      lines.push('<div class="mel-summary__line"><span>' + esc(a.product.title) + (a.product.variants.length > 1 ? ' · ' + esc(a.variant.title) : '') + '</span><span>+' + money(a.variant.price) + '</span></div>');
    });
    this.root.querySelector('[data-mel-lines]').innerHTML = lines.join('');
    this.root.querySelector('[data-mel-total]').textContent = money(total);
    }
    var badge = this.root.querySelector('[data-mel-badge]');
    if (badge) badge.textContent = v.title === 'Default Title' ? this.data.title : v.title;
    // spec table
    var spec = document.querySelector('[data-mel-spec]');
    if (spec) {
      var rows = this.specRows();
      spec.innerHTML = rows.map(function (r) { return '<tr><td>' + esc(r[0]) + '</td><td>' + esc(r[1]) + '</td></tr>'; }).join('');
    }
    this.draw(addons);
  };

  /* ---------- drawing ---------- */
  var EXTRA_DEFS = '<linearGradient id="mel-rose" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#C98B7A"/><stop offset=".45" stop-color="#F6D3C8"/><stop offset=".55" stop-color="#C98B7A"/><stop offset="1" stop-color="#9E6656"/></linearGradient>' +
    '<linearGradient id="mel-holo" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#F7A8C4"/><stop offset=".3" stop-color="#A7DCCB"/><stop offset=".6" stop-color="#C8B6F0"/><stop offset="1" stop-color="#FFF1A8"/></linearGradient>' +
    '<linearGradient id="mel-sheen" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#fff" stop-opacity=".0"/><stop offset=".45" stop-color="#fff" stop-opacity=".45"/><stop offset=".55" stop-color="#fff" stop-opacity="0"/></linearGradient>' +
    '<linearGradient id="mel-wallg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#FB97DF"/><stop offset="1" stop-color="#3B1E6E"/></linearGradient>' +
    '<filter id="mel-drop" x="-10%" y="-10%" width="120%" height="130%"><feDropShadow dx="2" dy="4" stdDeviation="3" flood-opacity=".25"/></filter>';
  Cfg.prototype.draw = function (addons) {
    var fn = this.extraModes[this.mode];
    if (fn) {
      var gold = '<linearGradient id="mel-gold" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#B8892B"/><stop offset=".45" stop-color="#F6DB8F"/><stop offset=".55" stop-color="#B8892B"/><stop offset="1" stop-color="#8C6517"/></linearGradient><linearGradient id="mel-silver" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#9EA3A8"/><stop offset=".45" stop-color="#F4F5F7"/><stop offset=".55" stop-color="#9EA3A8"/><stop offset="1" stop-color="#6F747A"/></linearGradient><pattern id="mel-grain" width="12" height="60" patternUnits="userSpaceOnUse"><path d="M0 10 Q6 14 12 10 M0 40 Q6 36 12 40" stroke="#000" stroke-opacity=".06" fill="none"/></pattern><linearGradient id="mel-print" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#FCE4EC"/><stop offset=".55" stop-color="#F7A8C4"/><stop offset="1" stop-color="#E5487A"/></linearGradient>';
      this.preview.innerHTML = '<svg viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg"><defs>' + gold + EXTRA_DEFS + '</defs>' + fn(this.ctx(), this) + '</svg>';
      return;
    }
    var mode = this.mode, all = this.allText();
    var shape = shapeFrom(this.optValue(/shape|style|design/i) || this.prop('shape'), this.defShape);
    if (mode === 'arch3d') shape = shapeFrom(this.optValue(/shape/i), this.defShape === 'rect' || this.defShape === 'oval' ? this.defShape : 'arch');
    var size = sizeFrom(this.optValue(/size|dimension/i) || this.prop('size'), mode) || (mode === 'printed' ? { w: 3, h: 6 } : mode === 'arch3d' ? { w: 4, h: 6 } : { w: 3.5, h: 6 });
    var finish = this.optValue(/finish|colou?r|paint/i) || (mode === 'printed' ? 'print' : 'unpainted');
    var custom = this.prop('colour');
    var fill = mode === 'printed' ? null : (colourFor(finish, custom) || COLOURS.unpainted);
    var name = this.prop('name');
    var font = lc(this.prop('font'));
    var fontCss = font.indexOf('script') > -1 ? "'Great Vibes', cursive" : font.indexOf('serif') > -1 ? "'Fraunces', serif" : "'Bricolage Grotesque', sans-serif";
    var fontW = font.indexOf('script') > -1 ? 400 : font.indexOf('serif') > -1 ? 600 : 800;
    var signAddon = null, hasSignGroup = !!this.form.querySelector('[data-mel-addon-role="sign"]');
    addons.forEach(function (a) { if (a.role === 'sign') signAddon = a; });
    var signFill = signAddon ? (colourFor(signAddon.variant.title) || colourFor(signAddon.product.title) || '#FFFFFF') : '#FFFFFF';
    if (signAddon && signAddon.variant.title === 'Default Title') signFill = colourFor(signAddon.product.title) || '#181357';
    var showName = name && (!hasSignGroup || signAddon);
    var stand = all.indexOf('stand') > -1 && all.indexOf('no stand') < 0;

    // scene: 600×600, floor at 500. Fit object + person.
    var FLOOR = 500, personH = 5.6, maxH = Math.max(size.h, this.person ? personH : 0);
    var span = size.w + (this.person ? 2.2 : 0);
    var scale = Math.min(380 / maxH, 470 / span);
    var W = size.w * scale, H = size.h * scale;
    var ox = this.person ? 300 - (W + 1.4 * scale) / 2 + 1.4 * scale : 300 - W / 2;
    var oy = FLOOR - H;
    var defs = '<defs>' +
      '<linearGradient id="mel-gold" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#B8892B"/><stop offset=".45" stop-color="#F6DB8F"/><stop offset=".55" stop-color="#B8892B"/><stop offset="1" stop-color="#8C6517"/></linearGradient>' +
      '<linearGradient id="mel-silver" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#9EA3A8"/><stop offset=".45" stop-color="#F4F5F7"/><stop offset=".55" stop-color="#9EA3A8"/><stop offset="1" stop-color="#6F747A"/></linearGradient>' +
      '<pattern id="mel-vinyl" width="40" height="40" patternUnits="userSpaceOnUse"><rect width="40" height="40" fill="#FCE4EC"/><circle cx="10" cy="10" r="6" fill="#FB97DF"/><circle cx="30" cy="30" r="6" fill="#F2B8C6"/></pattern>' +
      '<pattern id="mel-grain" width="12" height="60" patternUnits="userSpaceOnUse"><rect width="12" height="60" fill="none"/><path d="M0 10 Q6 14 12 10 M0 40 Q6 36 12 40" stroke="#000" stroke-opacity=".06" fill="none"/></pattern>' +
      '<linearGradient id="mel-print" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#FCE4EC"/><stop offset=".55" stop-color="#F7A8C4"/><stop offset="1" stop-color="#E5487A"/></linearGradient>' +
      '<clipPath id="mel-clip"><path d="' + outline(shape, W, H, ox, oy) + '"/></clipPath>' +
      '</defs>';
    var g = '';
    // shadow
    g += '<ellipse cx="' + (ox + W / 2) + '" cy="' + (FLOOR + 4) + '" rx="' + (W * 0.58) + '" ry="10" fill="#000" fill-opacity=".14"/>';

    if (mode === 'arch3d') {
      var depth = Math.max(10, 0.3 * 3.28 * scale * 0.55), frame = Math.max(8, 0.82 * scale);
      var outer = outline(shape, W, H, ox, oy);
      var inner = outline(shape, Math.max(4, W - frame * 2), Math.max(4, H - frame), ox + frame, oy + frame);
      var dark = shade(fill, -0.18);
      // back face + depth
      g += '<g transform="translate(' + (depth * 0.9) + ',' + (-depth * 0.5) + ')"><path d="' + outer + ' ' + inner + '" fill="' + dark + '" fill-rule="evenodd"/></g>';
      g += '<path d="' + outer + ' ' + inner + '" fill="' + fill + '" fill-rule="evenodd" stroke="rgba(0,0,0,.12)" stroke-width="1"/>';
      if (fill === COLOURS.unpainted) g += '<path d="' + outer + ' ' + inner + '" fill="url(#mel-grain)" fill-rule="evenodd"/>';
      if (all.indexOf('part') > -1 && all.indexOf('all in one') < 0) g += '<line x1="' + (ox + W / 2) + '" y1="' + oy + '" x2="' + (ox + W / 2) + '" y2="' + (oy + frame) + '" stroke="#000" stroke-opacity=".3"/>';
      if (showName) g += '<text x="' + (ox + W / 2) + '" y="' + (oy + frame * 0.72) + '" text-anchor="middle" font-family="' + fontCss + '" font-weight="' + fontW + '" font-size="' + Math.min(frame * 0.8, W / Math.max(4, name.length) * 1.6) + '" fill="' + signFill + '">' + esc(name) + '</text>';
    } else if (mode === 'printed') {
      var p = outline(shape, W, H, ox, oy);
      g += '<path d="' + p + '" fill="#FFFFFF" stroke="rgba(0,0,0,.15)"/>';
      if (this.artUrl) g += '<image href="' + this.artUrl + '" x="' + ox + '" y="' + oy + '" width="' + W + '" height="' + H + '" preserveAspectRatio="xMidYMid slice" clip-path="url(#mel-clip)"/>';
      else {
        g += '<g clip-path="url(#mel-clip)"><rect x="' + ox + '" y="' + oy + '" width="' + W + '" height="' + H + '" fill="url(#mel-print)"/>' +
          '<path d="M' + ox + ' ' + (oy + H * 0.78) + ' Q' + (ox + W * 0.3) + ' ' + (oy + H * 0.66) + ' ' + (ox + W * 0.6) + ' ' + (oy + H * 0.76) + ' T' + (ox + W) + ' ' + (oy + H * 0.72) + ' V' + (oy + H) + ' H' + ox + 'Z" fill="#181357" fill-opacity=".25"/>' +
          '<circle cx="' + (ox + W * 0.78) + '" cy="' + (oy + H * 0.2) + '" r="' + (W * 0.1) + '" fill="#FFF1A8"/></g>';
        g += '<text x="' + (ox + W / 2) + '" y="' + (oy + H * 0.5) + '" text-anchor="middle" font-family="Bricolage Grotesque, sans-serif" font-weight="800" font-size="' + Math.min(W * 0.18, 40) + '" fill="#181357">' + esc(name || 'Your design') + '</text>';
      }
      if (all.indexOf('correx') > -1 || all.indexOf('fold') > -1 || this.mode === 'printed' && all.indexOf('foamex') < 0 && all.indexOf('ultraboard') < 0) {
        g += '<path d="M' + ox + ' ' + (oy + H / 3) + ' H' + (ox + W) + ' M' + ox + ' ' + (oy + 2 * H / 3) + ' H' + (ox + W) + '" stroke="#000" stroke-opacity=".18" stroke-dasharray="6 5" clip-path="url(#mel-clip)"/>';
      }
      if (stand) g += '<path d="M' + (ox + W * 0.5) + ' ' + (FLOOR - H * 0.4) + ' L' + (ox + W * 0.5 + 26) + ' ' + FLOOR + '" stroke="#8C8172" stroke-width="5"/>';
    } else {
      var q = outline(shape, W, H, ox, oy);
      // timber stand peeking behind
      g += '<path d="M' + (ox + W * 0.5) + ' ' + (FLOOR - H * 0.45) + ' L' + (ox + W * 0.5 + 34) + ' ' + FLOOR + '" stroke="#B48A5E" stroke-width="7"/>';
      g += '<path d="' + q + '" fill="' + fill + '" stroke="rgba(0,0,0,.14)"/>';
      if (fill === COLOURS.unpainted) g += '<path d="' + q + '" fill="url(#mel-grain)"/>';
      if (shape === 'layered') g += '<path d="' + outline('layered', W, H * 0.8, ox, oy + H * 0.2) + '" fill="' + shade(fill, -0.08) + '"/>';
      if (showName) g += '<text x="' + (ox + W / 2) + '" y="' + (oy + H * 0.36) + '" text-anchor="middle" font-family="' + fontCss + '" font-weight="' + fontW + '" font-size="' + Math.min(W * 0.2, W * 1.7 / Math.max(3, name.length)) + '" fill="' + signFill + '" stroke="rgba(0,0,0,.08)">' + esc(name) + '</text>';
    }
    // person for scale
    if (this.person) {
      var ph = personH * scale, px = ox - 1.2 * scale, py = FLOOR - ph, hr = ph * 0.065;
      g += '<g fill="#9E9A94" opacity=".85"><circle cx="' + px + '" cy="' + (py + hr) + '" r="' + hr + '"/>' +
        '<path d="M' + (px - ph * 0.11) + ' ' + (py + ph * 0.16) + ' Q' + px + ' ' + (py + ph * 0.13) + ' ' + (px + ph * 0.11) + ' ' + (py + ph * 0.16) + ' L' + (px + ph * 0.1) + ' ' + (py + ph * 0.55) + ' L' + (px + ph * 0.07) + ' ' + FLOOR + ' H' + (px + ph * 0.01) + ' L' + px + ' ' + (py + ph * 0.6) + ' L' + (px - ph * 0.01) + ' ' + FLOOR + ' H' + (px - ph * 0.07) + ' L' + (px - ph * 0.1) + ' ' + (py + ph * 0.55) + ' Z"/></g>';
      g += '<text x="' + px + '" y="' + (FLOOR + 30) + '" text-anchor="middle" font-family="Instrument Sans, sans-serif" font-size="12" fill="#6B645B">5ft 6in</text>';
    }
    // dimension label
    g += '<text x="' + (ox + W / 2) + '" y="' + (FLOOR + 30) + '" text-anchor="middle" font-family="Instrument Sans, sans-serif" font-weight="600" font-size="13" fill="#181357">' + fmtFt(size.w) + ' wide × ' + fmtFt(size.h) + ' tall</text>';
    this.preview.innerHTML = '<svg viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg">' + defs + g + '</svg>';
  };
  function fmtFt(n) { var r = Math.round(n * 2) / 2; return (r % 1 ? r.toFixed(1) : r.toFixed(0)) + 'ft'; }
  function shade(hex, amt) {
    if (!hex || hex.charAt(0) !== '#') return '#9C8F80';
    var n = parseInt(hex.slice(1), 16), r = n >> 16, gg = (n >> 8) & 255, b = n & 255;
    var f = function (c) { return Math.max(0, Math.min(255, Math.round(c + c * amt))); };
    return '#' + ((1 << 24) + (f(r) << 16) + (f(gg) << 8) + f(b)).toString(16).slice(1);
  }

  /* ---------- extra preview styles ---------- */
  var EXTRA = {
    'baby pink': '#F6C1D6', 'light blue': '#A9D3F2', purple: '#7B5CFF', 'rose gold': 'url(#mel-rose)', beige: '#E6D3B3',
    clear: 'rgba(220,235,245,.55)', frosted: 'rgba(240,244,248,.85)', red: '#B8262B', yellow: '#F2C230', orange: '#F2A93B', mint: '#A7DCCB', lilac: '#C8B6F0', blush: '#F2B8C6', butter: '#FFE8A3', sage: '#8FAE8B'
  };
  function tint(name, fallback) {
    var n = lc(name);
    for (var k in EXTRA) if (n.indexOf(k) > -1) return EXTRA[k];
    return colourFor(name) || fallback;
  }
  function num(text, re) { var m = lc(text).replace(/,/g, '.').match(re); return m ? parseFloat(m[1]) : null; }
  function cmSize(text) { // "40 x 30cm" → {w,h} in cm; "6ft" → h cm; "3m" → w cm
    var t = lc(text).replace(/,/g, '.'), m;
    if ((m = t.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*cm/))) return { w: +m[1], h: +m[2] };
    if ((m = t.match(/(\d+(?:\.\d+)?)\s*cm/))) return { h: +m[1] };
    if ((m = t.match(/(\d+(?:\.\d+)?)\s*mm/))) return { h: +m[1] / 10 };
    if ((m = t.match(/(\d+(?:\.\d+)?)\s*ft/))) return { ft: +m[1] };
    if ((m = t.match(/(\d+(?:\.\d+)?)\s*m\b/))) return { m: +m[1] };
    return {};
  }
  function T(x, y, s, size, fill, font, weight, extra) {
    return '<text x="' + x + '" y="' + y + '" text-anchor="middle" dominant-baseline="middle" font-family="' + (font || "'Bricolage Grotesque', sans-serif") + '" font-weight="' + (weight || 800) + '" font-size="' + size + '" fill="' + fill + '"' + (extra || '') + '>' + esc(s) + '</text>';
  }
  function person(x, floor, h) {
    var hr = h * 0.065, y = floor - h;
    return '<g fill="#9E9A94" opacity=".85"><circle cx="' + x + '" cy="' + (y + hr) + '" r="' + hr + '"/><path d="M' + (x - h * 0.11) + ' ' + (y + h * 0.16) + ' Q' + x + ' ' + (y + h * 0.13) + ' ' + (x + h * 0.11) + ' ' + (y + h * 0.16) + ' L' + (x + h * 0.1) + ' ' + (y + h * 0.55) + ' L' + (x + h * 0.07) + ' ' + floor + ' H' + (x + h * 0.01) + ' L' + x + ' ' + (y + h * 0.6) + ' L' + (x - h * 0.01) + ' ' + floor + ' H' + (x - h * 0.07) + ' L' + (x - h * 0.1) + ' ' + (y + h * 0.55) + ' Z"/></g>';
  }
  Cfg.prototype.ctx = function () {
    var font = lc(this.prop('font'));
    return {
      all: this.allText(), name: this.prop('name'), colour: this.prop('colour'), tintName: this.prop('tint') || this.optValue(/colou?r|finish|material|mirror/i),
      size: this.prop('size') || this.optValue(/size|height|width|dimension|table|segments/i), shape: this.prop('shape') || this.optValue(/shape|window/i),
      fontCss: font.indexOf('script') > -1 ? "'Great Vibes', cursive" : font.indexOf('serif') > -1 ? "'Fraunces', serif" : "'Bricolage Grotesque', sans-serif",
      fontW: font.indexOf('script') > -1 ? 400 : font.indexOf('serif') > -1 ? 600 : 800
    };
  };
  Cfg.prototype.extraModes = {
    sign: function (c) {
      var mirror = c.all.indexOf('mirror') > -1, mdf = c.all.indexOf('mdf') > -1;
      var fill = mdf ? COLOURS.unpainted : mirror ? (c.all.indexOf('rose') > -1 ? 'url(#mel-rose)' : c.all.indexOf('silver') > -1 ? 'url(#mel-silver)' : 'url(#mel-gold)') : tint(c.tintName, '#FFFFFF');
      var sz = cmSize(c.size), w = sz.w || 40, h = sz.h || 30, k = Math.min(440 / w, 300 / h), W = w * k, H = h * k, x = 300 - W / 2, y = 250 - H / 2;
      var g = '<rect x="0" y="0" width="600" height="600" fill="#EDE7DF"/>';
      g += '<rect x="' + x + '" y="' + y + '" width="' + W + '" height="' + H + '" fill="none" stroke="#181357" stroke-opacity=".25" stroke-dasharray="6 6" rx="6"/>';
      g += '<g filter="url(#mel-drop)">' + T(300, 250, c.name || 'Your name', Math.min(H * 0.55, W * 1.6 / Math.max(3, (c.name || 'Your name').length)), fill, c.fontCss, c.fontW, ' stroke="rgba(0,0,0,.12)" stroke-width="1"') + '</g>';
      g += T(300, y + H + 26, w + ' × ' + h + 'cm sheet', 13, '#6B645B', "'Instrument Sans', sans-serif", 600);
      return g;
    },
    box: function (c, self) {
      var kind = self.kind, sz = cmSize(c.size), H = sz.h || (kind === 'cube' ? 50 : 70), Wd = kind === 'cube' ? 50 : kind === 'mdfplinth' ? 35 : 30;
      var set = c.all.indexOf('set of 3') > -1, heights = set ? [70, 90, 50] : [H];
      var maxH = Math.max.apply(null, heights.concat([170])), k = 380 / maxH, FLOOR = 500, out = '';
      var painted = colourFor(c.tintName || '', c.colour);
      var front = painted && c.all.indexOf('print') < 0 ? painted : 'url(#mel-print)';
      if (c.all.indexOf('custom') > -1) front = c.colour || '#8FAE8B';
      var total = heights.length * Wd * k + (heights.length - 1) * 16, x0 = 330 - total / 2;
      heights.forEach(function (h, i) {
        var w = Wd * k, hh = h * k, d = w * 0.35, x = x0 + i * (w + 16), y = FLOOR - hh;
        out += '<path d="M' + (x + w) + ' ' + y + ' l' + d + ' ' + (-d * 0.5) + ' v' + hh + ' l' + (-d) + ' ' + (d * 0.5) + ' Z" fill="' + shade(front.charAt(0) === '#' ? front : '#F7A8C4', -0.15) + '"/>';
        out += '<path d="M' + x + ' ' + y + ' l' + d + ' ' + (-d * 0.5) + ' h' + w + ' l' + (-d) + ' ' + (d * 0.5) + ' Z" fill="' + shade(front.charAt(0) === '#' ? front : '#FCE4EC', 0.06) + '"/>';
        out += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + hh + '" fill="' + front + '" stroke="rgba(0,0,0,.1)"/>';
        if (front === COLOURS.unpainted) out += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + hh + '" fill="url(#mel-grain)"/>';
        if (c.name && i === 0) out += T(x + w / 2, y + hh * 0.3, c.name, Math.min(w * 0.22, w * 1.6 / Math.max(3, c.name.length)), c.all.indexOf('gold') > -1 ? 'url(#mel-gold)' : '#181357', c.fontCss, c.fontW);
        out += T(x + w / 2, FLOOR + 22, h + 'cm', 12, '#6B645B', "'Instrument Sans', sans-serif", 600);
      });
      out = person(x0 - 50, FLOOR, 170 * k) + out;
      return out;
    },
    table: function (c) {
      var ft = cmSize(c.size).ft || 6, W = ft * 30.48, k = Math.min(440 / W, 3.2), w = W * k, h = 74 * k, x = 300 - w / 2, FLOOR = 470, y = FLOOR - h;
      var g = '<rect x="' + (x - 6) + '" y="' + (y - 8) + '" width="' + (w + 12) + '" height="8" fill="#E9E4DA"/>';
      if (c.all.indexOf('3-sided') > -1 || c.all.indexOf('3 sided') > -1) g += '<path d="M' + (x + w) + ' ' + y + ' l26 -14 v' + h + ' l-26 14 Z" fill="#C9578E"/>';
      g += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="url(#mel-print)"/>';
      g += T(300, y + h / 2, c.name || 'YOUR NAME', Math.min(h * 0.35, w / Math.max(4, (c.name || 'YOUR NAME').length) * 1.6), '#FFFFFF', c.fontCss, c.fontW);
      g += T(300, FLOOR + 26, ft + 'ft table · 74cm tall', 13, '#181357', "'Instrument Sans', sans-serif", 600);
      return g;
    },
    wall: function (c) {
      var m = cmSize(c.size).m || 3, W = m * 100, H = 220, ret = c.all.indexOf('with returns') > -1, k = Math.min(440 / (W + (ret ? 60 : 0) + 60), 300 / H), w = W * k, h = H * k, FLOOR = 480, x = 330 - w / 2, y = FLOOR - h, g = '';
      if (ret) { g += '<path d="M' + x + ' ' + y + ' l-34 18 v' + h + ' l34 -18 Z" fill="#2E2A6E"/><path d="M' + (x + w) + ' ' + y + ' l34 18 v' + h + ' l-34 -18 Z" fill="#2E2A6E"/>'; }
      g += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="url(#mel-wallg)"/>';
      var txt = c.name || 'YOUR LOGO', fs = Math.max(9, Math.min(18, 22 * k)), cols = Math.max(2, Math.floor(w / (txt.length * fs * 0.7 + 18)));
      for (var r = 0; r < Math.floor(h / (fs * 2.6)); r++) for (var q = 0; q < cols; q++) {
        var tx = x + (q + 0.5 + (r % 2 ? 0.5 : 0)) * (w / cols); if (tx > x + w - 10) continue;
        g += T(tx, y + (r + 0.6) * fs * 2.6, txt, fs, '#F2C230', c.fontCss, c.fontW);
      }
      for (var p = 1; p < m; p++) g += '<line x1="' + (x + p * 100 * k) + '" y1="' + y + '" x2="' + (x + p * 100 * k) + '" y2="' + FLOOR + '" stroke="#000" stroke-opacity=".15"/>';
      g += person(x - 20, FLOOR, 170 * k);
      g += T(x + w / 2, FLOOR + 24, m + 'm wide × 2.2m tall', 13, '#181357', "'Instrument Sans', sans-serif", 600);
      return g;
    },
    frame: function (c) {
      var big = c.all.indexOf('large') > -1, w = big ? 100 : 74, h = big ? 74 : 56;
      if (c.all.indexOf('portrait') > -1) { var t = w; w = h; h = t; }
      var k = Math.min(420 / w, 380 / h), W = w * k, H = h * k, x = 300 - W / 2, y = 260 - H / 2, b = Math.min(W, H) * (c.all.indexOf('slim') > -1 ? 0.1 : c.all.indexOf('wide') > -1 ? 0.2 : 0.14);
      var shape = shapeFrom(c.shape, 'rounded'); if (lc(c.shape).indexOf('heart') > -1) shape = 'oval';
      var win = outline(shape, W - 2 * b, H - 2.6 * b, x + b, y + b);
      var g = '<path d="M' + x + ' ' + y + ' h' + W + ' v' + H + ' h' + (-W) + ' Z ' + win + '" fill="url(#mel-print)" fill-rule="evenodd" stroke="rgba(0,0,0,.12)"/>';
      g += T(300, y + H - b * 0.8, c.name || 'Sophie & James', Math.min(b * 0.9, W / 12), '#FFFFFF', c.fontCss, c.fontW);
      g += T(300, y + H + 26, w + ' × ' + h + 'cm', 13, '#181357', "'Instrument Sans', sans-serif", 600);
      return g;
    },
    wheel: function (c) {
      var n = num(c.size, /(\d+)/) || 8; if (n > 32) n = 32; if (c.all.indexOf('17') > -1 && n < 17) n = 20;
      var cx = 300, cy = 250, r = 190, g = '<path d="M300 300 L250 520 M300 300 L350 520" stroke="#181357" stroke-width="10" stroke-linecap="round"/>';
      g += '<circle cx="' + cx + '" cy="' + cy + '" r="' + (r + 12) + '" fill="#181357"/>';
      for (var i = 0; i < n; i++) {
        var a0 = (i / n) * 2 * Math.PI - Math.PI / 2, a1 = ((i + 1) / n) * 2 * Math.PI - Math.PI / 2;
        g += '<path d="M' + cx + ' ' + cy + ' L' + (cx + r * Math.cos(a0)) + ' ' + (cy + r * Math.sin(a0)) + ' A' + r + ' ' + r + ' 0 0 1 ' + (cx + r * Math.cos(a1)) + ' ' + (cy + r * Math.sin(a1)) + ' Z" fill="' + (i % 2 ? '#FCE4EC' : '#FB97DF') + '"/>';
        g += '<circle cx="' + (cx + (r + 6) * Math.cos(a0)) + '" cy="' + (cy + (r + 6) * Math.sin(a0)) + '" r="3.5" fill="#F2C230"/>';
      }
      if (c.all.indexOf('wipe') > -1) g += '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="url(#mel-sheen)"/>';
      g += '<circle cx="' + cx + '" cy="' + cy + '" r="34" fill="#FFFFFF" stroke="#181357" stroke-width="4"/>' + T(cx, cy, c.name || 'SPIN', 14, '#181357');
      g += '<path d="M' + (cx - 14) + ' ' + (cy - r - 26) + ' h28 l-14 30 Z" fill="#F2C230" stroke="#181357" stroke-width="2"/>';
      g += T(300, 560, n + ' segments · 90cm wheel', 13, '#181357', "'Instrument Sans', sans-serif", 600);
      return g;
    },
    tree: function (c) {
      var col = c.colour || '#2F5D50', duo = c.all.indexOf('duo') > -1, FLOOR = 500, g = '';
      var trees = duo ? [[170, 230], [120, 400]] : [[num(c.size, /(\d(?:\.\d)?)\s*m/) * 100 || 170, 300]];
      var k = 380 / 180;
      g += person(80, FLOOR, 170 * k);
      trees.forEach(function (t) {
        var h = t[0] * k, x = t[1], w = h * 0.62, y = FLOOR - h;
        for (var i = 0; i < 3; i++) { var ty = y + i * h * 0.25, tw = w * (0.55 + i * 0.22); g += '<path d="M' + x + ' ' + ty + ' L' + (x + tw / 2) + ' ' + (ty + h * 0.38) + ' H' + (x - tw / 2) + ' Z" fill="' + col + '"/>'; }
        g += '<rect x="' + (x - 10) + '" y="' + (FLOOR - h * 0.14) + '" width="20" height="' + (h * 0.14) + '" fill="#8C6517"/>';
        if (c.name) g += T(x, y + h * 0.62, c.name, Math.max(10, w / 12), '#FFFFFF', c.fontCss, c.fontW);
        g += T(x, FLOOR + 22, (t[0] / 100) + 'm', 12, '#6B645B', "'Instrument Sans', sans-serif", 600);
      });
      return g;
    },
    item: function (c, self) {
      var kind = self.kind, g = '', name = c.name, col = c.colour || '#FB97DF';
      var ink = '#FFFFFF', bg = '<rect width="600" height="600" fill="#EDE7DF"/>';
      if (kind === 'coaster') {
        g = bg + '<ellipse cx="300" cy="420" rx="170" ry="26" fill="#000" fill-opacity=".1"/><circle cx="300" cy="280" r="170" fill="' + (c.all.indexOf('white') > -1 ? '#FFFFFF' : col) + '"/>';
        if (c.all.indexOf('border') > -1) g += '<circle cx="300" cy="280" r="150" fill="#FFFFFF"/><circle cx="300" cy="280" r="150" fill="none" stroke="' + col + '" stroke-width="2"/>';
        g += T(300, 280, name || 'Your logo', 40, c.all.indexOf('white') > -1 || c.all.indexOf('border') > -1 ? col : ink, c.fontCss, c.fontW);
      } else if (kind === 'stirrer') {
        var sc = c.all.indexOf('mirror') > -1 ? (c.all.indexOf('rose') > -1 ? 'url(#mel-rose)' : c.all.indexOf('silver') > -1 ? 'url(#mel-silver)' : 'url(#mel-gold)') : tint(c.tintName, '#FFFFFF');
        g = bg + '<g transform="rotate(-30 300 300)"><rect x="285" y="210" width="30" height="330" rx="15" fill="' + sc + '" stroke="rgba(0,0,0,.12)"/><circle cx="300" cy="160" r="95" fill="' + sc + '" stroke="rgba(0,0,0,.12)"/>' + T(300, 160, name || 'LOGO', 30, c.all.indexOf('mirror') > -1 ? 'rgba(255,255,255,.75)' : (lc(c.tintName).indexOf('black') > -1 ? '#FFFFFF' : '#181357'), c.fontCss, c.fontW) + '</g>';
      } else if (kind === 'popcorn') {
        var pc = c.colour || '#B8262B';
        g = bg + '<path d="M190 180 H410 L380 500 H220 Z" fill="#FFFFFF" stroke="rgba(0,0,0,.1)"/>';
        if (c.all.indexOf('solid') < 0) for (var s = 0; s < 5; s++) g += '<path d="M' + (200 + s * 44) + ' 180 h22 l' + (-3 - s) + ' 320 h-18 Z" fill="' + pc + '"/>'; else g += '<path d="M190 180 H410 L380 500 H220 Z" fill="' + pc + '"/>';
        for (var b = 0; b < 14; b++) g += '<circle cx="' + (200 + (b * 37) % 200) + '" cy="' + (170 - (b % 3) * 14) + '" r="18" fill="#FFF6DA" stroke="#E9D9A6"/>';
        g += '<rect x="235" y="300" width="130" height="80" rx="10" fill="#FFFFFF"/>' + T(300, 340, name || 'LOGO', 22, pc, c.fontCss, c.fontW);
      } else if (kind === 'lolly') {
        g = bg + '<g transform="rotate(-20 300 300)"><rect x="110" y="270" width="380" height="60" rx="30" fill="#E5C99B" stroke="#C9A96E"/>' + T(300, 300, name || "Ava's 1st Birthday", 24, '#7A5A2E', c.fontCss, c.fontW) + '</g>';
      } else if (kind === 'stencil') {
        var stc = tint(c.tintName, '#1E1C18');
        g = bg + '<rect x="280" y="400" width="40" height="110" rx="14" fill="' + stc + '"/><circle cx="300" cy="260" r="170" fill="' + stc + '"/><circle cx="300" cy="260" r="150" fill="none" stroke="#EDE7DF" stroke-opacity=".3"/>' + T(300, 260, name || 'LOGO', 52, '#EDE7DF', c.fontCss, 800);
      } else if (kind === 'bottle') {
        var lc2 = c.colour || '#1F5BD6';
        for (var i = 0; i < 3; i++) { var bx = 190 + i * 110; g += '<rect x="' + (bx - 14) + '" y="100" width="28" height="30" rx="4" fill="#1F5BD6"/><path d="M' + (bx - 16) + ' 130 Q' + (bx - 44) + ' 160 ' + (bx - 44) + ' 200 V490 Q' + (bx - 44) + ' 510 ' + (bx - 24) + ' 510 H' + (bx + 24) + ' Q' + (bx + 44) + ' 510 ' + (bx + 44) + ' 490 V200 Q' + (bx + 44) + ' 160 ' + (bx + 16) + ' 130 Z" fill="rgba(200,225,245,.7)" stroke="rgba(0,0,0,.08)"/>' + (c.all.indexOf('labels only') > -1 && i > 0 ? '' : '<rect x="' + (bx - 44) + '" y="280" width="88" height="110" fill="' + lc2 + '"/>' + T(bx, 335, name || 'LOGO', 16, '#FFFFFF', c.fontCss, c.fontW)); }
        g = bg + g;
      } else if (kind === 'sticker') {
        var fillS = c.all.indexOf('holo') > -1 ? 'url(#mel-holo)' : c.all.indexOf('chrome') > -1 ? 'url(#mel-silver)' : c.all.indexOf('glitter') > -1 ? 'url(#mel-gold)' : c.all.indexOf('clear') > -1 ? 'rgba(255,255,255,.4)' : (c.colour || '#FFFFFF');
        var shp = lc(c.shape);
        var path = shp.indexOf('circle') > -1 ? outline('oval', 340, 340, 130, 90) : shp.indexOf('square') > -1 ? outline('rect', 340, 340, 130, 90) : outline('rounded', 340, 340, 130, 90);
        g = bg + '<path d="' + path + '" fill="' + fillS + '" stroke="#FB97DF" stroke-width="2" stroke-dasharray="8 6"/>' + T(300, 260, name || 'Hip hip hooray!', 34, '#181357', c.fontCss, c.fontW);
        if (c.all.indexOf('gloss') > -1 || c.all.indexOf('chrome') > -1) g += '<path d="' + path + '" fill="url(#mel-sheen)"/>';
      } else if (kind === 'vinyl') {
        var vc = c.all.indexOf('custom') > -1 ? (c.colour || '#FB97DF') : tint(c.tintName || 'black', '#1E1C18');
        if (c.all.indexOf('frost') > -1) vc = 'rgba(255,255,255,.75)';
        g = '<rect width="600" height="600" fill="' + (c.all.indexOf('frost') > -1 ? '#9FB7C9' : '#EDE7DF') + '"/>' + T(300, 280, name || 'Olivia', 90, vc, c.fontCss, c.fontW);
      } else if (kind === 'cutout') {
        var k = 380 / 183, ht = (num(c.size, /(\d)\s*ft/) || 5) * 30.48 * k, cx = 340, FLOOR = 500, top = FLOOR - ht;
        g = person(150, FLOOR, 170 * k) + '<path d="M' + (cx - ht * 0.18) + ' ' + FLOOR + ' Q' + (cx - ht * 0.32) + ' ' + (top + ht * 0.5) + ' ' + (cx - ht * 0.2) + ' ' + (top + ht * 0.25) + ' Q' + (cx - ht * 0.28) + ' ' + top + ' ' + cx + ' ' + top + ' Q' + (cx + ht * 0.28) + ' ' + top + ' ' + (cx + ht * 0.2) + ' ' + (top + ht * 0.25) + ' Q' + (cx + ht * 0.32) + ' ' + (top + ht * 0.5) + ' ' + (cx + ht * 0.18) + ' ' + FLOOR + ' Z" fill="#C98B4B" stroke="#FB97DF" stroke-width="3" stroke-dasharray="8 6"/>';
        g += '<circle cx="' + (cx - ht * 0.07) + '" cy="' + (top + ht * 0.14) + '" r="' + (ht * 0.02) + '" fill="#1E1C18"/><circle cx="' + (cx + ht * 0.07) + '" cy="' + (top + ht * 0.14) + '" r="' + (ht * 0.02) + '" fill="#1E1C18"/>';
        g += T(cx, FLOOR + 22, (num(c.size, /(\d)\s*ft/) || 5) + 'ft tall', 12, '#6B645B', "'Instrument Sans', sans-serif", 600);
      } else if (kind === 'cart') {
        var body = tint(c.tintName, '#FFFFFF');
        g = '<path d="M120 170 H480 V200 Q465 220 450 200 Q435 220 420 200 Q405 220 390 200 Q375 220 360 200 Q345 220 330 200 Q315 220 300 200 Q285 220 270 200 Q255 220 240 200 Q225 220 210 200 Q195 220 180 200 Q165 220 150 200 Q135 220 120 200 Z" fill="#E58FA8"/><path d="M140 200 V300 M460 200 V300" stroke="#C9A24A" stroke-width="6"/><rect x="110" y="300" width="380" height="16" fill="#C9A24A"/><rect x="120" y="316" width="360" height="150" fill="' + body + '" stroke="rgba(0,0,0,.1)"/><circle cx="170" cy="480" r="38" fill="none" stroke="#1E1C18" stroke-width="8"/><circle cx="430" cy="480" r="38" fill="none" stroke="#1E1C18" stroke-width="8"/>' + T(300, 140, name || 'SWEETS', 34, '#181357', c.fontCss, c.fontW);
      }
      return g;
    }
  };

  /* ---------- add to basket ---------- */
  Cfg.prototype.submit = function () {
    var self = this, btn = this.root.querySelector('[data-mel-submit]'), msg = this.root.querySelector('[data-mel-msg]');
    var v = this.variant(), ref = 'MEL-' + Date.now().toString(36).toUpperCase();
    btn.disabled = true; btn.textContent = 'Adding…'; msg.textContent = '';
    var fd = new FormData();
    fd.append('id', v.id); fd.append('quantity', this.qty());
    this.form.querySelectorAll('input[name^="properties["]').forEach(function (i) {
      if (i.disabled) return;
      if (i.type === 'file') { if (i.files && i.files[0]) fd.append(i.name, i.files[0]); return; }
      if (i.value) fd.append(i.name, i.value);
    });
    fd.append('properties[_Order ref]', ref);
    var addons = this.chosenAddons().map(function (a) { return { id: a.variant.id, quantity: 1, properties: { 'For': self.data.title, '_Order ref': ref } }; });
    var cartAdd = (this.root.getAttribute('data-cart-add') || '/cart/add') + '.js';
    fetch(cartAdd, { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        if (!addons.length) return null;
        return fetch(cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: addons }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
      })
      .then(function () { window.location.href = self.root.getAttribute('data-cart') || '/cart'; })
      .catch(function (err) {
        btn.disabled = false; btn.textContent = 'Add to basket';
        msg.textContent = (err && (err.description || err.message)) || 'Sorry, something went wrong — please try again.';
      });
  };

  /* ---------- tabs ---------- */
  function tabs(root) {
    root.querySelectorAll('[data-tab]').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('[data-tab]').forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        root.querySelectorAll('[data-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== t.getAttribute('data-tab'); });
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-mel-cfg]').forEach(function (r) { if (!r._mel) { r._mel = new Cfg(r); } });
    (scope || document).querySelectorAll('[data-mel-tabs]').forEach(function (r) { if (!r._melTabs) { r._melTabs = 1; tabs(r); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
